export default "__VITE_ASSET__vISXQDLM__"